"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyAlreadyFavourited = void 0;
const wishlist_exception_1 = require("./wishlist-exception");
class StudyAlreadyFavourited extends wishlist_exception_1.WishlistException {
    constructor(wishlistId, studyId) {
        super(`Favourite with study id ${studyId} from wishlist ${wishlistId} already exists.`);
        this.wishlistId = wishlistId;
        this.studyId = studyId;
        this.name = 'StudyAlreadyFavourited';
    }
}
exports.StudyAlreadyFavourited = StudyAlreadyFavourited;
